import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";
import { format, compareAsc } from "date-fns";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import * as commonData from "@app/lib/common_data";
import * as util from "@app/lib/utility";

import { SelectStatPeriod, getDefinedPeriod } from "@app/components/Stat/SelectStatPeriod";
import ExcelDownloadBtn from "@app/components/Stat/ExcelDownloadBtn";
import ViewOption from "./Components/ViewOption";

import Main from "./HQ/Main";
import App from "./HQ/App";
import Branch from "./HQ/Branch";
import Nursery from "./HQ/Nursery";
import NurserySub from "./HQ/NurserySub";
import Content from "./HQ/Content";
import IndexBranch from "./index_branch"

const minDate = "2022-03-01"; // 통계 데이터 제공 시작일
const showLastYearShortCut = new Date().getFullYear() >= 2023; // 2023년부터 이전 학년도 버튼 활성화
const getPeriodToStat = ({ startDate, endDate, type }) => {
    return {
        startDate: format(startDate, "yyyy-MM-dd"),
        endDate: format(endDate, "yyyy-MM-dd"),
        type: type,
    };
};
const StatTomonoteHQ = (props) => {
    const [statPeriod, setStatPeriod] = useState(getPeriodToStat(getDefinedPeriod("week", "current")));
    const [branchList, setBranchList] = useState(false);
    const [view, setView] = useState(false);
    const [viewOption, setViewOption] = useState(false);
    const [selectedViewOption, setSelectedViewOption] = useState(false);
    const [selectedViewSubOption, setSelectedViewSubOption] = useState(false);
    const [mainStat, setMainStat] = useState(false);
    const [categoryStat, setCategoryStat] = useState(false);
    const [page, setPage] = useState("hq");
    const parentRef = useRef();

    useEffect(() => {
        if (!branchList) {
            commonData.getBranchList(axios, (err, branchList) => {
                if (err) {
                    toast.error(err);
                } else {
                    setBranchList(branchList);
                }
            });
        }
        return () => {};
    }, []);

    const changePage = (e) => {
        setPage(e);
    }

    const onPeriodChangeHandler = (startDate, endDate, type) => {
        setMainStat(false);
        setCategoryStat(false);
        setStatPeriod(getPeriodToStat({ startDate, endDate, type }));
    };
    const onViewSelected = (e) => {
        setView(e);
    };
    const onViewBack = () => {
        if (selectedViewSubOption) {
            setSelectedViewSubOption(false);
        } else {
            setCategoryStat(false);
            setView(false);
            setViewOption(false);
            setSelectedViewOption(false);
        }
    };

    const updateViewOption = (options, defaultSelected = "-") => {
        setViewOption(options);
        setSelectedViewOption(defaultSelected);
    };

    const onViewOptionSelected = (selected) => {
        setSelectedViewOption(selected);
    };

    const onViewSubOptionSelected = (selected) => {
        setSelectedViewSubOption(selected);
    };

    return (
        <div>
        {page == "hq" ? (<div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <h2 className="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-4pageheader-title">
                            토모노트
                            {view == "nursery" && selectedViewSubOption ? ` - ${selectedViewSubOption.nurseryUniqName}` : ""}
                        </h2>
                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 float-right">
                            <select className="form-control form-control-lg" name="month" value={"hq"} onChange={(e) => changePage(e.target.value)} style={{ fontSize: "1.3em" }}>
                                <option value="hq">본사</option>
                                <option value="branch">지사</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <div className="row align-items-center mb-3">
                        {view != false && (
                            <div className="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-4" style={{ minWidth: "59px", maxWidth: "59px" }}>
                                <button
                                    className="btn btn-default"
                                    style={{
                                        marginRight: "10px",
                                        border: "0px",
                                        width: "44px",
                                    }}
                                    type="button"
                                    onClick={onViewBack}
                                >
                                    <span className="fa fa-lg fa-chevron-left" aria-hidden="true" />
                                </button>
                            </div>
                        )}
                        <div className="col-xl-3 col-lg-3 col-md-9 col-sm-9 col-8">
                            <SelectStatPeriod id="select-stat-period" showLastYearShortCut={showLastYearShortCut} minDate={minDate} onPeriodChangeHandler={onPeriodChangeHandler} />
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-5 col-sm-12 col-12">
                            {(view === "nursery" || view === "branch") && !selectedViewSubOption && <ViewOption data={viewOption} selected={selectedViewOption} onOptionSelect={onViewOptionSelected} />}
                        </div>
                        {view !== false && <ExcelDownloadBtn view={parentRef} statPeriod={statPeriod} />}
                    </div>
                    {view === false && <Main statPeriod={statPeriod} branchList={branchList} onViewSelected={onViewSelected} stat={mainStat} updateMainStat={setMainStat} />}
                    {view === "app" && <App statPeriod={statPeriod} ref={parentRef} />}
                    {view === "branch" && (
                        <Branch statPeriod={statPeriod} selectedViewOption={selectedViewOption} updateViewOption={updateViewOption} onViewOptionSelected={onViewOptionSelected} ref={parentRef} />
                    )}
                    {view === "nursery" &&
                        (!selectedViewSubOption ? (
                            <Nursery
                                branchList={branchList}
                                statPeriod={statPeriod}
                                selectedViewOption={selectedViewOption}
                                updateViewOption={updateViewOption}
                                onViewSubOptionSelected={onViewSubOptionSelected}
                                selectedViewSubOption={selectedViewSubOption}
                                statAll={categoryStat} updateCategoryStat={setCategoryStat}
                                ref={parentRef}
                            />
                        ) : (
                            <NurserySub statPeriod={statPeriod} selectedBranch={selectedViewOption} selectedNursery={selectedViewSubOption} ref={parentRef} />
                        ))}
                    {view === "content" && <Content statPeriod={statPeriod} ref={parentRef} />}
                </div>
            </div>
        </div>) : (<IndexBranch/>)}
        </div>
    );
};

export default StatTomonoteHQ;
